export default '3.7.0';


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/version.js
// module id = null
// module chunks = 